import { defineConfig, defineSemanticTokens } from "@chakra-ui/react";

import { defaultMTBTheme } from "./defaultMTBTheme";

const primary = defaultMTBTheme.colors.primary;

/**
 * Chakra UI v3 theme extension: registers an `mtb` color palette (semantic tokens)
 * and makes solid buttons use it by default — MTB primary (`MTB_PRIMARY_GREEN` / `#00BFA5`).
 */
export const mtbChakraConfig = defineConfig({
  theme: {
    semanticTokens: {
      colors: defineSemanticTokens.colors({
        mtb: {
          contrast: {
            value: { _light: "#FFFFFF", _dark: "#FFFFFF" },
          },
          fg: {
            value: { _light: "#056b5c", _dark: "#b8f7ee" },
          },
          subtle: {
            value: { _light: "#e8faf8", _dark: "#083931" },
          },
          muted: {
            value: { _light: "#d1f5f0", _dark: "#0d5249" },
          },
          emphasized: {
            value: { _light: "#a3ebe3", _dark: "#118577" },
          },
          solid: {
            value: { _light: primary, _dark: primary },
          },
          focusRing: {
            value: { _light: primary, _dark: primary },
          },
          border: {
            value: { _light: primary, _dark: primary },
          },
        },
        /**
         * Unstyled solid buttons still resolve to the **gray** palette by default in many Chakra v3
         * layouts (Theme wrapper uses gray; gray.solid is gray.900 → reads as black).
         * Align gray “solid” fills with MTB primary so default solid buttons match legacy branding.
         */
        gray: {
          solid: {
            value: { _light: primary, _dark: primary },
          },
          focusRing: {
            value: { _light: primary, _dark: primary },
          },
        },
      }),
    },
    recipes: {
      button: {
        defaultVariants: {
          size: "md",
          variant: "solid",
          colorPalette: "mtb",
        } as Record<string, string>,
      },
    },
  },
});
